import { Inject, Injectable } from '@angular/core';
import { EntityService } from "@shared/services/entity.service";
import { EntityFeatureNameEnum } from "@shared/contracts/entity-store.contract";
import { ExtraJobType } from "@generated/graphql";
import { ExtraJob } from "@modules/extra-job/models/extra-job.model";
import { EXTRA_JOB_STORE, ExtraJobStore } from "@modules/extra-job/store/extra-job.store";
import { Store } from "@ngrx/store";
import { ExtraJobFactory, extraJobFactory } from "@modules/extra-job/factories/extra-job.factory";

@Injectable({
  providedIn: 'root'
})
export class ExtraJobService extends EntityService<EntityFeatureNameEnum.ExtraJob, ExtraJobType, ExtraJob> {
  constructor (
    @Inject(EXTRA_JOB_STORE) protected readonly entityStore: ExtraJobStore,
    protected readonly store: Store
  ) {
    super(store, entityStore)
  }

  get factory (): ExtraJobFactory {
    return extraJobFactory;
  }
}
